var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#43418E;stroke-width:4;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#43418E;stroke-width:4;stroke-linejoin:round;}\n\t.st2{fill:none;stroke:#43418E;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "compass") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "compass"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32,
    cy: 36,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32,
    cy: 36,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 26,
    y1: 4,
    x2: 38,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 32,
    y1: 4,
    x2: 32,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 29.2,
    y1: 38.8,
    x2: 20.7,
    y2: 47.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 43.3,
    y1: 24.7,
    x2: 34.8,
    y2: 33.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 32,
    y1: 20,
    x2: 32,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 16,
    y1: 36,
    x2: 16,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 32,
    y1: 52,
    x2: 32,
    y2: 52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 48,
    y1: 36,
    x2: 48,
    y2: 36
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.7f60ecc7b40d78695722e813786d88fb.svg";
export { ForwardRef as ReactComponent };